import React from 'react';
import TransitionFormFields from './TransitionFormFields';
import { transitionSchema } from '../../../lib/transition-schemas';

export default function ClosedLostForm({ values, onChange, errors }) {
  return <TransitionFormFields schema={transitionSchema('closed_lost')} values={values} onChange={onChange} errors={errors} />;
}
